import { httpCreate } from './http';

const http = httpCreate('/srv/business-card-user');

export const businessCardUser = {
	getCardDetailForUserId(activityId, userId, params) {
		return http.get(`/detail/pc/${activityId}/${userId}`, { params });
	},
};
